import { render } from "./ReliefList.vue?vue&type=template&id=9b49c66a&scoped=true"
import script from "./ReliefList.vue?vue&type=script&lang=js"
export * from "./ReliefList.vue?vue&type=script&lang=js"

import "./ReliefList.vue?vue&type=style&index=0&id=9b49c66a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b49c66a"]])

export default __exports__